import { put, retry, takeEvery } from 'redux-saga/effects';
import ActionTypes from '../../../../Data/ActionTypes';
import getDynamicNewsletterQuery from './getDynamicNewsletterQuery';
import { NAVIGATION_BLOCKS } from '../../../../Data/Constants';
import { Newsletters } from '../../../../Data/NewsletterBrands';

/**
 * Worker - requested by below function and carries out any async work
 */
export function* getDynamicNewsletterWorker(action) {
  const { visitorId, destinationPageNumber, fallbackNewsletter } =
    action.payload;
  const maxTries = 3; // 3 retries
  const delayLength = 1000; // 1 seconds
  yield put({
    type: 'NAVIGATION_CONTROLS/setNavigationBlockOnPage',
    payload: {
      pageNumber: destinationPageNumber,
      blockName: NAVIGATION_BLOCKS.GET_DYNAMIC_NEWSLETTER,
      isPreventingNavigation: true,
    },
  });

  try {
    const dynamicNewsletterId = yield retry(
      maxTries,
      delayLength,
      getDynamicNewsletterQuery,
      { variables: { visitorId, fallbackNewsletter } }
    );

    const dynamicNewsletterName = Newsletters[dynamicNewsletterId];

    if (dynamicNewsletterName) {
      yield put({
        type: 'NEWSLETTER/setDynamicNewsletterName',
        payload: { dynamicNewsletterName },
      });
    }
  } finally {
    yield put({
      type: 'NAVIGATION_CONTROLS/setNavigationBlockOnPage',
      payload: {
        pageNumber: destinationPageNumber,
        blockName: NAVIGATION_BLOCKS.GET_DYNAMIC_NEWSLETTER,
        isPreventingNavigation: false,
      },
    });
  }
}

/**
 * Listens for every VALIDATE_PHONE action that has been dispatched and will handle the saga of validating a phone number
 */
export default function* getDynamicNewsletterWatcher() {
  yield takeEvery(
    ActionTypes.GET_DYNAMIC_NEWSLETTER,
    getDynamicNewsletterWorker
  );
}
